export default {
    eyebrow: "Contact",
    title: "Tell us what you need",
    description: "Request a demo or send a general enquiry. Our team will get back to you shortly.",
    backToLanding: "Back to landing",
    help: {
        title: "Fast response",
        description: "We review every request and reply as soon as possible.",
    },
    fields: {
        fullName: {
            label: "Full name",
            placeholder: "Your full name",
            hint: "Use your real name to help us follow up quickly.",
        },
        workEmail: {
            label: "Work email",
            placeholder: "name@company.com",
            hint: "Use a business email address.",
        },
        company: {
            label: "Company",
            placeholder: "Your company name",
            hint: "The company you represent.",
        },
        requestType: {
            label: "Request type",
            options: {
                demo: "Request a demo",
                general: "General enquiry",
            },
        },
        relationshipType: {
            label: "Your role (optional)",
            placeholder: "Select your role",
            options: {
                shipper: "Shipper",
                receiver: "Receiver",
                notify_party: "Notify party",
                freight_forwarder: "Freight forwarder",
                carrier: "Carrier",
                customs_broker: "Customs broker",
                port_authority: "Port authority",
                insurance_provider: "Insurance provider",
                inspection_agency: "Inspection agency",
                regulatory_authority: "Regulatory authority",
                land_transport: "Land transport",
                supplier: "Supplier",
                customer: "Customer",
                other: "Other",
            },
        },
        message: {
            label: "Message",
            placeholder: "Share your context, goals, or questions...",
            hint: "Maximum 2000 characters.",
        },
        privacyConsent: {
            label: "I agree to the processing of my data for contact purposes.",
            hint: "Required to submit this form.",
        },
    },
    validation: {
        fullNameRequired: "Full name is required.",
        workEmailRequired: "Work email is required.",
        workEmailInvalid: "Please enter a valid email address.",
        companyRequired: "Company is required.",
        messageRequired: "Message is required.",
        messageTooLong: "Message must be at most 2000 characters.",
        privacyConsentRequired: "You must accept privacy consent to continue.",
    },
    submit: {
        cta: "Send request",
        successTitle: "Request sent",
        successDescription: "Thank you. We received your request and will contact you soon.",
        successToast: "Contact request sent successfully.",
        backHome: "Go to landing",
    },
};
